import { GraphQLQueryClass } from "@harea/component";
import {TTimeOff, TTimeOffsResponse } from "@harea/component";
export class DayOffListQuery
    implements GraphQLQueryClass<TTimeOffsResponse, TResponse>
{
    public queryKey: string = "App.bsm.Project.DayOffListQuery";
    public gql: string = `
        query DayOffList($data: JSONObject, $pageSize: Float, $page: Float, $sort: [TFilterSort!], $key: String) {
            timeoffs (
                filter: { 
                    data: $data, 
                    page: $page, 
                    pageSize: $pageSize,
                    sort: $sort,
                    key: $key
                }
            ) {
                total
                data {
                    id
                    createdAt
                    dateBegin
                    dateEnd
                    type {
                        designation
                    }
                    countWorkingDays
                    status
                    approvals {
                        approver {
                            id
                            fullName
                        }
                        isApproved
                        isRefused
                    }
                    employee {
                        id
                        fullName
                        matricule
                        department {
                            designation
                        }
                    }
                    userCreator {
                        id
                        employee {
                            fullName
                        }
                    }
                }
            }
        }
    `;
    variables?: any;
    constructor(variables?: any) {
        const { includeAbsences, ...rest } = variables || {};

        const mergedData = {
            ...(rest?.data || {}),
            type: {
                ...(rest?.data?.type || {}),
                ...(!includeAbsences ? { designation_notEquals: 'ABSENCE' } : {}),
            },
        };

        if (rest?.data?.employee && rest?.data?.employee?.department?.id === -1) {
            mergedData.employee.department = undefined
        }
        
        this.variables = {
            ...rest,
            data: mergedData
        };
    }
    mapFn(data: TResponse): TTimeOffsResponse {
        return {
            total: data.timeoffs.total,
            data: data.timeoffs.data,
        };
    }
}

export type TResponse = {
    timeoffs:{
        total:number,
        data:Array<TTimeOff>
    }
}